import { jsx as j } from "react/jsx-runtime";
import { Fragment as h } from "react";
import { c as g } from "./exports-xpZYqD67.js";
function I(e) {
  if (e == null) return "";
  const n = e.toLowerCase().split(" ");
  for (let t = 0; t < n.length; t++)
    n[t] = n[t].charAt(0).toUpperCase() + n[t].substring(1);
  return n.join(" ");
}
function _(e) {
  if (!e) return "";
  const n = e.charAt(0).toUpperCase(), t = e.slice(1).toLowerCase();
  return n + t;
}
function s(e, n) {
  const t = /\{\{([^}]+)\}\}/g;
  let r = "", o = 0, a;
  for (; (a = t.exec(e)) !== null; ) {
    const [i, p] = a, c = a.index;
    c > o && (r += e.slice(o, c)), n.hasOwnProperty(p) ? r += n[p] : r += i, o = c + i.length;
  }
  return o < e.length && (r += e.slice(o)), r;
}
function T(e) {
  return e ? e.replace(/^#{1,6}\s+/gm, "").replace(/\*\*(.*?)\*\*/g, "$1").replace(/\*(.*?)\*/g, "$1").replace(/~~(.*?)~~/g, "$1").replace(/`([^`]+)`/g, "$1").replace(/```[\s\S]*?```/g, "").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1").replace(/^>\s+/gm, "").replace(/^[-*_]{3,}$/gm, "").replace(/^[\s]*[-*+]\s+/gm, "").replace(/^[\s]*\d+\.\s+/gm, "").replace(/_(.*?)_/g, "$1").replace(/<[^>]*>/g, "").replace(/\n\s*\n/g, `
`).trim() : "";
}
function y(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function u(e, n, t) {
  return e.replace(new RegExp(y(n), "g"), t);
}
const l = (e, n, t) => {
  if (e === null) return null;
  try {
    let r = u(
      u(e, "{{", ""),
      "}}",
      ""
    ).split(/\b/);
    return n.forEach((o, a) => {
      r = r.map((i) => o === i ? t[a] : i);
    }), r.map((o, a) => /* @__PURE__ */ j(h, { children: o }, a));
  } catch (r) {
    return console.error("Error in replaceJSX:", r, { text: e, find: n }), g(r, {
      extra: {
        text: e,
        find: n,
        jsx: n
      }
    }), e;
  }
};
function w(e, n) {
  return l(e, Object.keys(n), Object.values(n));
}
function d(e) {
  return e;
}
const x = {
  getText: d,
  interpolate: w
};
function S(e) {
  if (typeof window < "u" && window.gettext)
    try {
      return window.gettext(e);
    } catch (n) {
      return console.warn("Error calling gettext:", n), e;
    }
  return e;
}
function f(e, n, t) {
  if (typeof window < "u" && window.ngettext)
    try {
      return window.ngettext(e, n, t);
    } catch (r) {
      return console.warn("Error calling ngettext:", r), t === 1 ? e : n;
    }
  return t === 1 ? e : n;
}
function m(e, n, t) {
  return f(e, n, t);
}
function E(e, n) {
  if (typeof window < "u" && window.django && !window.django.reactInterpolate && (window.django.reactInterpolate = function(t, r) {
    var a;
    const o = ((a = window.django.catalog) == null ? void 0 : a[t]) || t;
    return l(
      o,
      Object.keys(r),
      Object.values(r)
    );
  }, window.interpolate = window.django.reactInterpolate), typeof window < "u" && window.interpolate)
    try {
      return window.interpolate(e, n);
    } catch (t) {
      return console.warn("Error calling interpolate:", t), g(t, {
        extra: {
          fmt: e,
          variables: Object.keys(n)
        }
      }), e;
    }
  return l(e, Object.keys(n), Object.values(n));
}
function O(e, n) {
  if (typeof window < "u" && window.django && !window.django.interpolateString && (window.django.interpolateString = function(t, r) {
    var a;
    const o = ((a = window.django.catalog) == null ? void 0 : a[t]) || t;
    return s(o, r) || "";
  }, window.interpolateString = window.django.interpolateString), typeof window < "u" && window.interpolateString)
    try {
      return window.interpolateString(e, n);
    } catch (t) {
      return console.warn("Error calling interpolateString:", t), g(t, {
        extra: {
          fmt: e,
          variables: n
        }
      }), e;
    }
  return s(e, n) || "";
}
function $(e) {
  return new Intl.DisplayNames(["en"], {
    type: "language"
  }).of(e);
}
const k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getLanguageName: $,
  getText: S,
  getTextNoop: d,
  interpolate: E,
  interpolateNoop: w,
  interpolateString: O,
  nGetText: m,
  ngettext: f,
  translateNoop: x
}, Symbol.toStringTag, { value: "Module" }));
export {
  S as a,
  m as b,
  E as c,
  O as d,
  $ as e,
  I as f,
  d as g,
  T as h,
  w as i,
  k as j,
  f as n,
  s as r,
  _ as s,
  x as t
};
//# sourceMappingURL=i18n-DoHK2p36.js.map
